import React from 'react';
import Iframe from 'react-iframe';

const SecondaryBlockPage = () => (
  <Iframe
    url='https://visualization.audit.samiksha.samagra.io/public/dashboard/acf05f56-c4ac-45d2-9d95-193edc49a60a'
    width='100%'
    height='100%'
    display='initial'
    position='relative'
  />
);

export default SecondaryBlockPage;
